// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Modules
import { MedsurfCommonModule } from '../common/medsurf-common.module';
// Medsurf Lib
import { FlatDesignModule } from '@medsurf/flat-designs';
// Components
import { LoginComponent } from './login/login.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    RouterModule,
    TranslateModule,
    // Bootstrap
    NgbModule,
    // Medsurf Lib
    FlatDesignModule,
    // Modules
    MedsurfCommonModule
  ],
  declarations: [
    // Components
    LoginComponent
  ],
  exports: [
    // Components
    LoginComponent
  ]
})
export class UserModule {
}
